import React from 'react';
import './css/Footer.css';
import { NavLink, Link } from 'react-router-dom';

const Footer = () => {
    return (
        <div className=''>
            <section className='footer'>
                <div className='container'>
                    <div className='inner-content'>

                        <div className='row-wrapper'>
                            <div className='site-logo'>
                                <div className='img-box'>
                                    <Link to="/"><img src="/images/site-logo.png" alt="Site Logo" /></Link>
                                </div>
                                <p>KHANNA FEED LIMITED has gained immense expertise in supplying & trading of Healthy cattle feed.</p>
                                <div className='social-wrapper'>
                                    <ul>
                                        <li><Link to=""><i className="fa-brands fa-x-twitter"></i></Link></li>
                                        <li><Link to=""><i className="fa-brands fa-facebook"></i></Link></li>
                                        <li><Link to=""><i className="fa-brands fa-instagram"></i></Link></li>
                                        <li><Link to=""><i className="fa-brands fa-youtube"></i></Link></li>
                                    </ul>
                                </div>
                            </div>

                            <div className='site-menu'>
                                <h3>Quick Links</h3>
                                <ul>
                                    <li><NavLink to="/employee-attendance" className={({ isActive }) => isActive ? 'active' : ''}>Attendance</NavLink></li>
                                    <li><NavLink to="/meeting" className={({ isActive }) => isActive ? 'active' : ''}>Meeting</NavLink></li>
                                    <li><NavLink to="/my-order" className={({ isActive }) => isActive ? 'active' : ''}>My Order</NavLink></li>
                                    <li><NavLink to="/leaves" className={({ isActive }) => isActive ? 'active' : ''}>Leave Requests</NavLink></li>
                                </ul>
                            </div>

                            <div className='right-wrapper'>
                                <h3>Contact Us</h3>
                                <ul>
                                    <li><i className="fa-solid fa-location-dot"></i><Link to="#">Village Ikolaha, Tehsil Khanna Distt. Ludhiana, Punjab</Link></li>
                                    <li><i className="fa-solid fa-phone"></i><Link to="tel:+91 7710651111">+91 77 1065 1111</Link></li>
                                    <li><i className="fa-solid fa-envelope"></i><Link to="mailto:info@khannafeedltd.in">info@khannafeedltd.in</Link></li>
                                </ul>
                            </div>
                        </div>

                        <div className='copyright'>
                            <p>Copyright © 2025 | Khanna Feed</p>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default Footer;
